module.exports = __webpack_public_path__ + "static/media/lambdaschool.df8f7d3f.jpg";